import { render, staticRenderFns } from "./MedalCard.vue?vue&type=template&id=f2c1ea04&scoped=true&"
import script from "./MedalCard.vue?vue&type=script&lang=js&"
export * from "./MedalCard.vue?vue&type=script&lang=js&"
import style0 from "./MedalCard.vue?vue&type=style&index=0&id=f2c1ea04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c1ea04",
  null
  
)

export default component.exports